<template>
  <div>
    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="form" v-model="form" label-width="80px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="仓库名称">
                  <el-input v-model="form.strName" maxlength="32"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="仓库编号">
                  <el-input v-model="form.strCode" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="对接方式">
                  <el-select v-model="form.strType">
                    <el-option v-for="item in strTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="启用状态">
                  <el-select v-model="form.actFlag">
                    <el-option label="不限" value></el-option>
                    <el-option label="启用" value="T"></el-option>
                    <el-option label="禁用" value="F"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item>
                  <el-button @click="dialogFormVisible = true">新增</el-button>
                  <el-button type="primary" @click="onSubmit">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-card>

    <el-table :data="storeList" v-loading="loading" border :show-overflow-tooltip="true" stripe style="width: 100%" height="500">
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column prop="strName" label="仓库名称"></el-table-column>
      <el-table-column prop="strCode" label="仓库编号"></el-table-column>
      <el-table-column prop="strType" label="对接类型"></el-table-column>
      <el-table-column prop="apiUrl" label="对接地址" show-overflow-tooltip min-width="100px"></el-table-column>
      <el-table-column prop="strOwner" label="负责人" show-overflow-tooltip min-width="100px"></el-table-column>
      <el-table-column prop="ownerTel" label="联系电话" show-overflow-tooltip min-width="100px"></el-table-column>
      <el-table-column prop="ownerEmail" label="邮箱" show-overflow-tooltip min-width="100px"></el-table-column>

      <el-table-column prop="updated_at" label="更新" show-overflow-tooltip min-width="120px">
        <template slot-scope="scope">
          <el-row>{{scope.row.updated_at}}</el-row>
          <el-row>{{scope.row.updated_user}}</el-row>
        </template>
      </el-table-column>

      <el-table-column prop="actFlag" label="启用状态">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.actFlag" active-color="#13ce66" inactive-color="#ff4949" active-value="T" inactive-value="F" @change="chageAct(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="120px">
        <template slot-scope="scope">
          <!-- 编辑 -->
          <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDilog(scope.row)"></el-button>
          </el-tooltip>

          <!-- 删除 -->
          <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="delStore(scope.row.id)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog title="新增仓库" :visible.sync="dialogFormVisible" width="50%" @close="addDilogClosed" :close-on-click-modal="false">
      <el-form :model="addform" ref="addformRef" :rule="rules" size="mini" :rules="rules">
        <el-form-item label="仓库名称" prop="strName" :label-width="formLabelWidth">
          <el-input v-model="addform.strName" autocomplete="on" style="width:50%" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="仓库编号" prop="strCode" :label-width="formLabelWidth">
          <el-input v-model="addform.strCode" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="仓库ID" prop="warehouseCode" :label-width="formLabelWidth">
          <el-input v-model="addform.warehouseCode" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="仓库地址" prop="strAddr" :label-width="formLabelWidth">
          <el-input v-model="addform.strAddr" autocomplete="on" style="width:50%" maxlength="255"></el-input>
        </el-form-item>

        <el-form-item label="对接方式" prop="strType" :label-width="formLabelWidth">
          <el-select v-model="addform.strType">
            <el-option v-for="item in strTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="API地址" prop="apiUrl" :label-width="formLabelWidth">
          <el-input v-model="addform.apiUrl" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="负责人" prop="strOwner" :label-width="formLabelWidth">
          <el-input v-model="addform.strOwner" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" :label-width="formLabelWidth">
          <el-input v-model="addform.ownerTel" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="ownerEmail" :label-width="formLabelWidth">
          <el-input v-model="addform.ownerEmail" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="激活状态" prop="actFlag" :label-width="formLabelWidth">
          <el-radio-group v-model="addform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="addform.memo" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addStore">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑仓库" :visible.sync="editdialogFormVisible" width="50%" @close="editDilogClosed" :close-on-click-modal="false">
      <el-form :model="editform" ref="editformRef" :rule="rules" size="mini">
        <el-form-item label="仓库名称" prop="strName" :label-width="formLabelWidth">
          <el-input v-model="editform.strName" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="仓库编号" prop="strCode" :label-width="formLabelWidth">
          <el-input v-model="editform.strCode" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="仓库ID" prop="warehouseCode" :label-width="formLabelWidth">
          <el-input v-model="editform.warehouseCode" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="仓库地址" prop="strAddr" :label-width="formLabelWidth">
          <el-input v-model="editform.strAddr" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="对接方式" prop="strType" :label-width="formLabelWidth">
          <el-select v-model="editform.strType">
            <el-option v-for="item in strTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="API地址" prop="apiUrl" :label-width="formLabelWidth">
          <el-input v-model="editform.apiUrl" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>

        <el-form-item label="负责人" prop="strOwner" :label-width="formLabelWidth">
          <el-input v-model="editform.strOwner" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" :label-width="formLabelWidth">
          <el-input v-model="editform.ownerTel" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="ownerEmail" :label-width="formLabelWidth">
          <el-input v-model="editform.ownerEmail" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="激活状态" prop="actFlag" :label-width="formLabelWidth">
          <el-radio-group v-model="editform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="editform.memo" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveStore">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      // 正则表达式
      const regEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z_-])+/;
      if (regEmail.test(value) || !value) {
        return callback();
      }
      callback(new Error("请输入合法的邮箱"));
    };
    // 验证手机号规则
    var checkMobile = (rule, value, callback) => {
      if (value == "") {
        return callback();
      }

      const regMobile = /^(13[0-9]|15[012356789]|15[012356789]|17[5678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/;
      // 符合规则
      if (regMobile.test(value) || !value) {
        return callback();
      }
      callback(new Error("请输入合法的手机号"));
    };

    return {
      form: {
        strName: "",
        strCode: "",
        actFlag: "",
        strType: "",
      },
      addform: {
        strName: "",
        strAddr: "",
        strCode: "",
        warehouseCode: "",
        apiUrl: "",
        actFlag: "T",
        strType: "",
        strOwner: "",
        ownerTel: "",
        ownerEmail: "",
        status: "",
        memo: "",
      },
      editform: {
        strName: "",
        strAddr: "",
        strCode: "",
        warehouseCode: "",
        apiUrl: "",
        actFlag: "",
        strType: "",
        strOwner: "",
        ownerTel: "",
        ownerEmail: "",
        status: "",
        memo: "",
      },
      queryInfo: {
        query: [],
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,
      total: 0,
      selvalue: "",
      dialogFormVisible: false,
      editdialogFormVisible: false,
      formLabelWidth: "80px",
      rules: {
        strName: [
          { required: true, message: "请输入仓库名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        strCode: [
          { required: true, message: "请输入仓库编号", trigger: "blur" },
          { min: 3, max: 20, message: "长度3~20个字符", trigger: "blur" },
        ],
        warehouseCode: [
          { required: true, message: "请输入仓库ID", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        strType: [
          { required: true, message: "请选择仓库类型", trigger: "change" },
        ],
        ownerEmail: [{ validator: checkEmail, trigger: "blur" }],
        ownerTel: [{ validator: checkMobile, trigger: "blur" }],
      },
      storeList: [],
      strTypes: [
        { value: "0", label: "奇门" },
        { value: "1", label: "实时API" },
        { value: "2", label: "FTP" },
        { value: "3", label: "其他" },
      ],
      errmsg: "",
      loading: true,
    };
  },
  methods: {
    // 搜索
    onSubmit() {
      this.queryInfo.pagenum = 1;
      this.currentPage = 1;
      this.queryInfo.query = this.form;
      this.getStoreLists();
    },
    handleSizeChange(val) {
      this.queryInfo.pagesize = val;
      console.log(`每页 ${val} 条`);
      this.getStoreLists();
    },
    handleCurrentChange(val) {
      this.queryInfo.pagenum = val;
      console.log(`当前页: ${val}`);
      this.getStoreLists();
    },
    // 关闭新增窗口
    addDilogClosed() {
      this.$refs.addformRef.resetFields();
    },
    editDilogClosed() {
      this.$refs.editformRef.resetFields();
    },
    // 新增仓库
    addStore() {
      // this.$refs.addformRef.validate(async (valid) => {
      //   if (!valid) return;

      this.$http
        .post("addstr", this.addform)
        .then((response) => {
          const res = response.data;
          this.$message.success("添加仓库成功");
          this.dialogFormVisible = false;
          this.getStoreLists();
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
      // });
    },
    // 显示修改仓库对话框
    async showEditDilog(row) {
      let copy = Object.assign({}, row);
      this.editform = copy;
      this.editdialogFormVisible = true;
    },
    // 保存编辑仓库信息
    saveStore() {
      // this.$refs.editformRef.validate(async (valid) => {
      //   if (!valid) return;

      this.$http
        .post("editstr", this.editform)
        .then((response) => {
          const res = response.data;
          this.$message.success("编辑仓库成功");
          this.editdialogFormVisible = false;
          this.getStoreLists();
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
      // });
    },
    // 获取仓库列表
    async getStoreLists() {
      this.loading = true;
      await this.$http
        .post("strlists", this.queryInfo)
        .then((response) => {
          const res = response.data;
          this.storeList = res.data.data;

          this.total = res.data.total;
          this.loading = false;
          this.currentPage = res.data.current_page;
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
          this.loading = false;
        });
    },
    // 删除仓库
    async delStore(strid) {
      // 弹框询问是否删除
      const confirmResult = await this.$confirm(
        "此操作将永久删除该仓库, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      console.log(confirmResult);

      // 确认删除
      if (confirmResult == "confirm") {
        await this.$http
          .delete("delstr/" + strid)
          .then((response) => {
            const res = response.data;
            this.$message.success("删除成功");

            this.getStoreLists();
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message);
          });
      }
    },
    // 变更激活状态
    async chageAct(storeInfo) {
      await this.$http
        .put("actstr/" + storeInfo.id + "/" + storeInfo.actFlag)
        .then((response) => {
          const res = response.data;
          this.$message.success(res.data);
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
    },
  },
  // 页面加载前
  created() {
    this.getStoreLists();
  },
};
</script>

<style lang="less" scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/basic/Store.vue